'use client';

import { ProductHeaderData } from '@/types/product-pages';
import { DesktopHeader } from './_components/desktop-header';
import { MobileHeader } from './_components/mobile-header';

interface HeaderProps {
  type?: 'voce' | 'suaempresa' | 'home';
  data?: ProductHeaderData | null;
}

export function Header({ type = 'home', data = null }: HeaderProps) {
  return (
    <header className="w-full">
      <DesktopHeader type={type} data={data} />
      <MobileHeader type={type} data={data} />
    </header>
  );
}
